let loading: Promise<typeof grecaptcha> | null = null

export function loadRecaptcha(): Promise<typeof grecaptcha> {
  if (loading) return loading
  loading = new Promise<typeof grecaptcha>((resolve, reject) => {
    const key = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
    if (!key) {
      reject(new Error('reCAPTCHA indisponível'))
      return
    }
    const timer = window.setTimeout(
      () => reject(new Error('Tempo de resposta do reCAPTCHA excedido')),
      15000,
    )
    function ready() {
      if (!window.grecaptcha?.ready) return
      window.grecaptcha.ready(() => {
        window.clearTimeout(timer)
        resolve(window.grecaptcha)
      })
    }
    if (window.grecaptcha?.ready) {
      ready()
      return
    }
    const script = document.createElement('script')
    script.id = 'recaptcha-sdk'
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(key)}&hl=pt-BR`
    script.async = true
    script.onload = ready
    script.onerror = () => {
      window.clearTimeout(timer)
      reject(new Error('Não foi possível carregar o reCAPTCHA'))
    }
    document.head.appendChild(script)
  }).catch((error) => {
    loading = null
    document.getElementById('recaptcha-sdk')?.remove()
    throw error
  })
  return loading
}
